export default __webpack_public_path__ + "static/media/canada.535abc2a.svg";